import { navigate } from "gatsby";
import React from "react";

const BlogCard = ({ blog }) => {
  return (
      <div className="mr-5 relative flex-grow-0 flex-shrink-0 basis-[45%] md:basis-[45%]">
        <article className="relative h-full">
          <div
              role="button"
              onClick={() => navigate(`/blogs/campfire-chats/${blog.slug}`)}
              className="h-full rounded-[10px] max-w-lg overflow-hidden relative block"
          >
            {/* Image Container */}
            <div className="rounded-[10px] overflow-hidden">
              <img
                  src={blog.thumbnailImage ? `${blog.thumbnailImage}?h=96` : ''}
                  alt={blog.title}
                  className="object-cover h-24 w-24 rounded-lg mb-2"
              />
            </div>
            {/* Content */}
            <div className="px-0 py-[10px] max-w-[180px]">
              <header className="block">
                <h4 className="text-[14px] tracking-wide line-clamp-3">
                  {blog.title}
                </h4>
              </header>
            </div>
          </div>
        </article>
      </div>
  );
};

export default BlogCard;
